import * as ActionTypes from "./types";

export const cookiesOpenSettings = () => ({ type: ActionTypes.COOKIES_OPEN_SETTINGS });
export const cookiesCloseSettings = () => ({ type: ActionTypes.COOKIES_CLOSE_SETTINGS });
export const cookiesAcceptAll = () => ({ type: ActionTypes.COOKIES_ACCEPT_ALL });
export const cookiesRejectNonEssential = () => ({ type: ActionTypes.COOKIES_REJECT_NON_ESSENTIAL });
export const cookiesSavePreferences = (payload) => ({ type: ActionTypes.COOKIES_SAVE_PREFERENCES, payload });
export const cookiesBootstrap = () => ({ type: ActionTypes.COOKIES_BOOTSTRAP });
